<template>
  <img
    src="@/assets/images/digger.png"
    alt="Loading..."
    :class="['loader-icon', { 'loader-icon--small': small }]"
  />
</template>

<script>
export default {
  name: 'DiggerLoader',
  props: {
    small: {
      type: Boolean,
      default: false,
    },
  },
}
</script>
